import ApiService from "api/ApiService";

interface NewSupportTicketResponse {
  ticket_id?: string;
}

export default class SupportService {
  private static getSupportURL(): string {
    return "support";
  }

  public static async newSupportTicket(
    email: string,
    topic: string,
    body: string,
  ): Promise<NewSupportTicketResponse> {
    try {
      const response = await ApiService.request(
        {
          url: `${this.getSupportURL()}/new`,
          method: "POST",
          data: {
            email,
            topic,
            body,
          },
        },
        false,
      );
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  }
}
